<template>
  <div>
    <div class="text-center">
      <div v-if="uploading">
        <loading-indicator />
      </div>
      <template v-else-if="completed"> Upload Complete </template>
      <template v-else>
        <div class="d-flex flex-row">
          <input
            id="formFile"
            class="form-control flex-grow-1"
            :class="dragging ? 'bg-light' : null"
            type="file"
            :multiple="multiple"
            :disabled="disabled"
            @dragenter="drag_enter"
            @dragleave="drag_leave"
            @change="set_attachment"
          />
          <div v-if="!noButton">
            <loading-button :disabled="disabled || !attachment" :method="upload" text="Upload" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FileUpload',
    props: {
      target: { type: String, default: undefined },
      formData: { type: Object, default: undefined },
      noButton: { type: Boolean, default: false },
      responseHandler: { type: Function, default: undefined },
      oneshot: { type: Boolean, default: true },
      disabled: { type: Boolean, default: undefined },
      multiple: { type: Boolean, default: undefined },
    },
    emits: ['attached', 'upload', 'response'],
    data() {
      return {
        attachment: false,
        uploading: false,
        completed: false,
        dragging: false,
      }
    },
    methods: {
      drag_enter(_) {
        this.dragging = true
      },
      drag_leave(_) {
        this.dragging = false
      },
      set_attachment(evt) {
        const files = evt.target.files || evt.dataTransfer.files
        if (files) {
          this.attachment = true
          for (const file of files) {
            this.file = file
            this.$emit(`attached`, evt)
            if (this.noButton && this.target) {
              this.upload()
            }
          }
        }
      },
      reset() {
        if (!this.oneshot) {
          this.attachment = false
          this.uploading = false
          this.completed = false
        }
      },
      upload() {
        if (!this.target) {
          return new Promise((resolve) => {
            this.$emit('upload', this.file)
            this.reset()
            return resolve(true)
          })
        }
        this.uploading = true
        const fd = new FormData()
        fd.set('file', this.file)
        if (this.formData) {
          for (const k of Object.keys(this.formData)) {
            fd.set(k, this.formData[k])
          }
        }
        return $api(this.target, { method: 'POST', body: fd }).then(
          (resp) => {
            this.uploading = false
            if (this.noButton) {
              this.completed = true
            }
            setTimeout(() => {
              this.$emit(`response`, resp)
            }, 1)
            if (this.responseHandler !== undefined) {
              this.responseHandler(resp)
            }
            this.reset()
          },
          () => {
            this.uploading = false
            if (this.noButton) {
              this.completed = true
            }
            this.reset()
          },
        )
      },
    },
  }
</script>

<style scoped></style>
